module.exports = __webpack_public_path__ + "static/2-9e9ab7e37b78005a91dce9b8bb11c872.png";